import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { DABInlineLoading, DABTextBoxWithSearch } from '../../components/dab';
import {Input } from "reactstrap";
import { orderAction } from '../../actions/orderAction';
import { donationAction } from '../../actions/donationAction';
import { userAction } from '../../actions/userAction';
import moment from 'moment';
import set from 'date-fns/fp/set/index.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

interface IUserPurchasesProps {
	dispatch: Dispatch<any>;
	userId: any;
	showSearch: any;
	title: any;
	orderData: any;
	donationData: any;
	userData: any;
}

const UserPurchaseDetail: React.SFC<IUserPurchasesProps> =
	({ dispatch, userId, showSearch, title, orderData, donationData, userData }) => {

		const initialUserOrdersInputValue = {
			customerEmail: userData?.item?.email,
			searchString : ""
		};

		const initialUserRecurringOrdersInputValue = {
			sortDirection: "desc",
			sortColumn: "",
			userId: userId,
			pageNumber: 1,
			pageSize: 5,
			isRecurring: true,
			searchString: "",
			userEmail: userData?.item?.email
		};

		const initialUserDonationsInputValue = {
			sortDirection: "desc",
			sortColumn:"",
			pageNumber: 1,
			pageSize: 5,
			userId: userId,
			isRecurring: false,
			searchString: ""
		};
		const initialUserDonationsRecurringInputValue = {
			sortDirection: "desc",
			sortColumn: "",
			pageNumber: 1,
			pageSize: 5,
			userId: userId,
			isRecurring: true
		};

		const initialUserPaymentInputValue = {
			pageNumber: 1,
			pageSize: 100,
			userId: userId
		};

		const [showPastOrderModal, setShowPastOrderModal] = useState(false);
		const [showRecurringOrderModal, setShowRecurringOrderModal] = useState(false);
		const [showPastDonationModal, setShowPastDonationModal] = useState(false);
		const [showRecurringDonationModal, setShowRecurringDonationModal] = useState(false);
		const [showPaymentModal, setShowPaymentModal] = useState(false);

		const [userOrderfilterInput, setOrderfilterilterInput] = useState(initialUserOrdersInputValue);
		const [userRecurringOrderfilterInput, setRecurringOrderFilterInput] = useState(initialUserRecurringOrdersInputValue);
		const [userRecurringDonationfilterInput, setRecurringDonationFilterInput] = useState(initialUserDonationsRecurringInputValue);
		const [pastDonationfilterInput, setPastDonationFilterInput] = useState(initialUserDonationsInputValue);
		const [userPaymentfilterInput, setUserPaymentFilterInput] = useState(initialUserPaymentInputValue);

		const [pastOrderList, setPastOrdersList] = useState([]);
		const [pastOrdersSearchText, setPastOrdersSearchText] = useState("");

		const [channelMsgSearchText, setChannelMsgSearchText] = useState("");
		const [userDonationsList, setUserDonationsList] = useState([]);

		const [userRecurringDonationsList, setUserRecurringDonationsList] = useState([]);
		const [recurringOrderSearchText, setRecurringOrderSearchText] = useState("");
		const [recurringOrdersList, setRecurringOrdersList] = useState([]);

		const [userPaymentList, setUserPaymentList] = useState([{ paymentMethodId: 0, userId: 0, title: "", cardType: "", isActive: false}]);

		React.useEffect(() => {
			dispatch(orderAction.orderGetByFilter(userOrderfilterInput));
			setShowPastOrderModal(true);
			dispatch(orderAction.orderRecurringGetByFilter(userRecurringOrderfilterInput));
			setShowRecurringOrderModal(true)
			dispatch(donationAction.donationGetByFilter(pastDonationfilterInput));
			setShowPastDonationModal(true);
			dispatch(userAction.userGetPaymentByFilter(userPaymentfilterInput));
			setShowPaymentModal(true);
		}, [userOrderfilterInput]);
		if (orderData) {
			if (orderData.isUserOrdersLoaded) {
				orderData.isUserOrdersLoaded = false;
				setShowPastOrderModal(false);
				setPastOrdersList(orderData.userorderData);
			}

			if (orderData.isUserRecurringOrdersLoaded) {
				orderData.isUserRecurringOrdersLoaded = false;
				setShowRecurringOrderModal(false);
				if (orderData.userRecurringorderData) {
				setRecurringOrdersList(orderData.userRecurringorderData);
				}
			}
			if (!orderData.isSuccess && orderData.isError) {
				orderData.isError = false;
				setShowPastOrderModal(false);
			}
		}

		if (donationData) {
			if (donationData.isUserDonationsLoaded) {
				donationData.isUserDonationsLoaded = false;
				setShowPastDonationModal(false);
				donationData.isUserRecurringDonationsLoaded = false;
				setShowRecurringDonationModal(false);
				// Splitting based on frequency
				const recurringDonations = donationData.userdonationData.filter(donation => donation.frequency !== null);
				const oneTimeDonations = donationData.userdonationData.filter(donation => donation.frequency === null);
				setUserDonationsList(oneTimeDonations);
				setUserRecurringDonationsList(recurringDonations);

			}
		}

		if (userData) {
			if (userData.isUserPaymentLoaded) {
				userData.isUserPaymentLoaded = false;
				setShowPaymentModal(false);
				setUserPaymentList(userData.userPaymentData);
			}
		}

		const handleFilter = (isPrivate, isChannel) => {
			if (isChannel) {
				pastDonationfilterInput.searchString = channelMsgSearchText;
				dispatch(donationAction.donationGetByFilter(pastDonationfilterInput));
				setShowPastDonationModal(true);
			} else {
				if (isPrivate) {
					userRecurringOrderfilterInput.searchString = recurringOrderSearchText;
					dispatch(orderAction.orderGetByFilter(userRecurringOrderfilterInput));
					setShowRecurringOrderModal(true);
				} else {
					userOrderfilterInput.searchString = pastOrdersSearchText;
					dispatch(orderAction.orderGetByFilter(userOrderfilterInput));
					setShowPastOrderModal(true);
				}
			}
		};

		const handleInputChange = (event, isPrivate, isChannel) => {
			if (isChannel) {
				setChannelMsgSearchText(event.target.value);
			}

			else {
				if (!isPrivate)
					setPastOrdersSearchText(event.target.value);	
			}
		};

		const handdlePaymentFilter = (e) => {
			const checked = e.target.checked
			if (checked) {
				const list = userPaymentList.filter((data) => {
					return data.isActive === checked
				})
				setUserPaymentList(list)
			} else {
				setUserPaymentList(userData.userPaymentData)
			}	
		}

		return (
			<div>
				<Row>
					<Col className="verCenter" lg="6">
						<h5>
							<span data-testid="orderTitle">Past Orders</span>
						</h5>
					</Col>
					{showSearch && <>
						<Col lg="6" style={{ float: "right" }}>
							<DABTextBoxWithSearch type="search" id="searchText" isRequired={false}
								onChange={(event) => { handleInputChange(event, false, false) }}
								value={pastOrdersSearchText} onClick={(event) => { handleFilter(false, false) }}
							/>
						</Col>
					</>
					}
				</Row>
				<table className="table table-bordered text-center" data-testid="orderTable">
					<thead>
						<tr>
							<th data-testid="orderDate" className="tdSize15" scope="col">Order Date</th>
							<th data-testid="orderId" className="tdSize15" scope="col">Order Number</th>
							<th data-testid="orderTotal" className="tdSize15" scope="col">Total Price</th>
							<th data-testid="orderItems" className="tdSize15">Link to Shopify order page</th>
							
						</tr>
					</thead>
					<tbody data-testid="orderTableBody">
						{!showPastOrderModal && pastOrderList && pastOrderList.map((data: any,index) =>
							<tr key={"order" + index}>
								<td data-testid={"orderDate" + index} key={"orderDate" + index} >
									{moment(data.date).format("MM/DD/YYYY")}
								</td>
								<td data-testid={"orderId" + index} key={"orderId" + index}>{data.orderNumber}</td>
								<td data-testid={"orderTotal" + index} key={"orderTotal" + index}>{data.totalPrice}</td>
								<td className="userPurchase"  data-testid={"orderItems" + index} key={"orderItems" + index}>
									<a className="detail-link" href={data.orderStatusUrl} target="_blank" rel="noopener noreferrer" title="View Order">
										<FontAwesomeIcon cursor='pointer' size='2x' icon={faEye} />
									</a></td>
							</tr>
						)}
						{showPastOrderModal &&
							<tr>
								<td colSpan={5} style={{ verticalAlign: "middle" }}>
									<DABInlineLoading />
								</td>
							</tr>
						}
						{!showPastOrderModal && pastOrderList.length <= 0 &&
							<tr>
								<td colSpan={5} style={{ verticalAlign: "middle" }}>
									No past orders found for this user
								</td>
							</tr>
						}

					</tbody>
				</table>
				<br />
				<Row >
					<Col className="verCenter" lg="6">
						<h5 data-testid="donationTitle">
							<span>Past Donations</span>
						</h5>
					</Col>
					{showSearch && <>
						<Col lg="6" style={{ float: "right" }}>
							<DABTextBoxWithSearch type="search" id="searchText" isRequired={false}
								onChange={(event) => { handleInputChange(event, false, true) }}
								value={channelMsgSearchText} onClick={(event) => { handleFilter(false, true) }}
							/>
						</Col>
					</>
					}
				</Row>
				<table className="table table-bordered text-center" data-testid="donationTable">
					<thead>
						<tr>
							<th data-testid="donationDate" className="tdSize15"  scope="col">Donation Date</th>
							<th data-testid="donationAmount" className="tdSize15" scope="col">Amount</th>
							<th data-testid="donationCurrency" className="tdSize15" scope="col">Currency</th>
							<th data-testid="donationStatus" className="tdSize15" scope="col">Status</th>
							<th data-testid="donationReceipt" className="tdSize15" scope="col">Receipt</th>
						</tr>
					</thead>
					<tbody data-testid="donationTableBody">
						{!showPastDonationModal && userDonationsList && userDonationsList.map((data: any,index) =>
							<tr key={"donation" + index}>
								<td data-testid={"donationDate" + index} key={"donationDate" + index} >
									{data.mostRecentDate ? moment(data.mostRecentDate).format("MM/DD/YYYY") : ""}
								</td>
								<td data-testid={"donationAmount" + index} key={"donationAmount" + index}>$ {data.amount}</td>
								<td data-testid={"donationCurrency" + index} key={"donationCurrency" + index}>USD</td>
								<td data-testid={"donationStatus" + index} key={"donationStatus" + index}>{data.status}</td>
								<td className="userPurchase" data-testid={"donationReceipt" + index} key={"donationReceipt" + index}>
									<a className="detail-link" href={data.transactionHistories?.[0]?.receiptUrl} target="_blank" rel="noopener noreferrer" title="View Receipt">
										<FontAwesomeIcon cursor='pointer' size='2x' icon={faEye} />
									</a></td>
							</tr>
						)}
						{showPastDonationModal &&
							<tr>
								<td colSpan={5} style={{ verticalAlign: "middle" }}>
									<DABInlineLoading />
								</td>
							</tr>
						}
						{!showPastDonationModal && userDonationsList.length <= 0 &&
							<tr>
								<td colSpan={5} style={{ verticalAlign: "middle" }}>
									No donation history found for this user.
								</td>
							</tr>
						}
					</tbody>
				</table>
				<br />
				<Row>
					<Col lg="6">
						<h5>
							<span data-testid="orderRecurringTitle">Recurring Orders</span>
						</h5>
					</Col>
				</Row>
				<table className="table table-bordered text-center" data-testid="orderRecurringTable">
					<thead>
						<tr>
							<th data-testid="orderRecurringSubscriptionId" className="tdSize15" scope="col">Subscription ID</th>
							<th data-testid="orderRecurringStatus" className="tdSize15" scope="col">Status</th>
							<th data-testid="orderRecurringStartDate" scope="col">Start Date</th>
							<th data-testid="orderRecurringEndDate" className="tdSize15" scope="col">End Date</th>
							<th data-testid="orderRecurringTotal" className="tdSize15" scope="col">Next Billing Date</th>
							<th data-testid="orderRecurringLink" className="tdSize15" scope="col">subscription Link</th>
						</tr>
					</thead>
					<tbody data-testid="orderRecurringTableBody">
						{!showRecurringOrderModal && recurringOrdersList && recurringOrdersList.map((data: any,index) =>
							<tr key={"orderRecurring" + index}>
								<td data-testid={"orderRecurringSubscriptionId" + index} key={"orderRecurringSubscriptionId" + index}>{data.id}</td>
								<td data-testid={"orderRecurringStatus" + index} key={"orderRecurringStatus" + index}>{data.subscriptionStatus}</td>
								<td data-testid={"orderRecurringStartDate" + index} key={"orderRecurringStartDate" + index}>{moment(data.createdAt).format("MM/DD/YYYY")}</td>
								<td data-testid={"orderRecurringEndDate" + index} key={"orderRecurringEndDate" + index}>{moment(data.lastOrderDatetime).format("MM/DD/YYYY")}</td>
								<td data-testid={"orderRecurringNextDate" + index} key={"orderRecurringNextDate" + index}>{moment(data.nextDate).format("MM/DD/YYYY")}</td>
								<td className="userPurchase" data-testid={"orderRecurringLink" + index} key={"orderRecurringLink" + index}>
									<a className="detail-link"  target="_blank" href={`https://sub.boldapps.net/admin/15605/customers?search=${userData?.item?.email}& status= all`}
									 rel="noopener noreferrer" title="View Subscription">
										<FontAwesomeIcon data-bs-toggle="tooltip"
											data-testid="orderRecurringLinkIcon"
											data-bs-placement="bottom"
											cursor='pointer' size='2x' icon={faEye} />
									</a>
								</td>
							</tr>
						)}
						{showRecurringOrderModal &&
							<tr>
								<td colSpan={6} style={{ verticalAlign: "middle" }}>
									<DABInlineLoading />
								</td>
							</tr>
						}
						{!showRecurringOrderModal && recurringOrdersList.length <= 0 &&
							<tr>
								<td colSpan={6} style={{ verticalAlign: "middle" }}>
									No Data Found
								</td>
							</tr>
						}

					</tbody>
				</table>

				<br />
				<Row >
					<Col lg="6">
						<h5>
							<span data-testid="donationRecurringTitle">Recurring Donations</span>
						</h5>
					</Col>
				</Row>
				<table className="table table-bordered text-center" data-testid="donationRecurringTable">
					<thead>
						<tr>
							<th data-testid="donationRecurringName" className="tdSize15"
								style={{ width: "15%" }} scope="col">Supscription Name</th>
							<th data-testid="donationRecurringStartDate"  scope="col">Start Date</th>
							<th data-testid="donationRecurringEndDate" scope="col">Current Period End Date</th>
							<th data-testid="donationRecurringNextDate" className="tdSize15" scope="col">Next Billing Date</th>
							<th data-testid="donationRecurringAmount" scope="col">Amount</th>
							<th data-testid="donationRecurringStatus" className="tdSize15" scope="col">Status</th>
							<th data-testid="donationRecurringReceipt" scope="col">Subscription Link</th>
						</tr>
					</thead>
					<tbody data-testid="donationRecurringTableBody">
						{!showRecurringDonationModal && userRecurringDonationsList && userRecurringDonationsList.map((data: any,index) =>
							<tr key={"donationRecurring" + index}>
								<td data-testid={"donationRecurringName" + index} key={"donationRecurringName" + index}>
									{data.donationType}
								</td>
								<td data-testid={"donationRecurringStartDate" + index} key={"donationRecurringStartDate" + index}>
									{data.startDate ? moment(data.startDate).format("MM/DD/YYYY") : ""}
								</td>
								<td data-testid={"donationRecurringEndDate" + index} key={"donationRecurringEndDate" + index}>
									{data.endDate ? moment(data.endDate).format("MM/DD/YYYY") : ""}
								</td>
								<td data-testid={"donationRecurringNextDate" + index} key={"donationRecurringNextDate" + index}>
									{data.nextDate ? moment(data.nextDate).format("MM/DD/YYYY") : ""}
								</td>
								<td data-testid={"donationRecurringAmount" + index} key={"donationRecurringAmount" + index}>
									$ {data.amount}
								</td>
								<td data-testid={"donationRecurringStatus" + index} key={"donationRecurringStatus" + index}>
									{data.status}
								</td>
								<td className="userPurchase" data-testid={"donationRecurringReceipt" + index} key={"donationRecurringReceipt" + index}>
									<a className="detail-link" href={'https://dashboard.stripe.com/subscription/'+data.id} target="_blank" rel="noopener noreferrer" title="View Receipt">
										<FontAwesomeIcon data-bs-toggle="tooltip"
											data-testid="donationRecurringReceiptIcon"
											data-bs-placement="bottom"
											cursor='pointer' size='2x' icon={faEye} />
									</a>
								</td>
							</tr>
						)}
						{showRecurringDonationModal &&
							<tr>
								<td colSpan={7} style={{ verticalAlign: "middle" }}>
									<DABInlineLoading />
								</td>
							</tr>
						}
						{!showRecurringDonationModal && userRecurringDonationsList.length <= 0 &&
							<tr>
								<td colSpan={7} style={{ verticalAlign: "middle" }}>
									No recurring donations found for this user.
								</td>
							</tr>
						}

					</tbody>
				</table>

				<br />
				<Row >
					<Col lg="4">
						<h5>
							<span data-testid="paymentsTitle">Wallet</span>
						</h5>
					</Col>
				</Row>
				<Row >
					<Col lg={4}>
						<table className="table table-bordered text-center" data-testid="paymentTable">
							<thead data-testid="paymentTableHead">
								<tr>
									<th data-testid="cardType" className="td50" scope="col">Card Type</th>
									<th data-testid="title" scope="col">Last 4 Digits</th>
								</tr>
							</thead>
							<tbody data-testid="paymentTableBody">
								{!showPaymentModal && userPaymentList && userPaymentList.map((data: any,index) =>
									<tr key={title + "111"}>
										<td data-testid={"cartType" + index}>{data.cardType}</td>
										<td data-testid={"title" + index}>{data.title}</td>
									</tr>
								)}
								{showPaymentModal &&
									<tr>
										<td colSpan={2} style={{ verticalAlign: "middle" }}>
											<DABInlineLoading />
										</td>
									</tr>
								}
								{!showPaymentModal && userPaymentList.length <= 0 &&
									<tr>
										<td colSpan={2} style={{ verticalAlign: "middle" }}>
											No Data Found
										</td>
									</tr>
								}

							</tbody>
						</table>
					</Col>
					<Col lg={2} data-testid="paymentActive">
						<Input type="checkbox" className='box-container-input' onChange={(e)=>handdlePaymentFilter(e) } /><span >Active</span>
					</Col>
				</Row>
			</div>
		);
	}

const mapStateToProps = (state: any) => {
	const { orderData, donationData, userData } = state;
	return {
		orderData, donationData, userData
	};
};

export default connect(mapStateToProps)(UserPurchaseDetail);